<script>
    import R, {LOADER} from "../lib/requests";
    import {PASSWORD_TIP} from "../lib/constants";
    import Alert from "../stores/alerts";
    import Prompt from "../components/pages/Prompt.svelte";
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import {setFocusTo} from "../lib/lib";

    export let account;

    let inputEmail = account.email ? false : true;
    let confirmPassword = '';
    let completed = false;
    let prompt = '';

    const submit = () => {

        const onSuccess = result => {
            completed = true;
            prompt = `<b>${account.email}||Σας έχει σταλεί μήνυμα στο ηλεκτρονικό σας ταχυδρομείο με οδηγίες για την επαλήθευση των στοιχείων σας.|Αν δεν βρείτε το μήνυμα στα εισερχόμενά σας ελέγξτε τον φάκελο «Ανεπιθύμητα».`
        }

        const onFailure = err => {
            if (err.code === 'account_exist') {
                Alert.warning("Εγγραφή - Επαλήθευση", err.message);
                return;
            }
            if (err.code === 'password_field_invalid') {
                Alert.warning("Κωδικός λογαριασμού", err.message, () => {
                    confirmPassword = '';
                    setFocusTo('password');
                });
                return;
            }
            if (err.code === 'field_invalid') {
                Alert.warning("Email λογαριασμού", "Πληκτρολογήστε μία έγκυρη διεύθυνση email για τον λογαριασμό σας.", () => {
                    setFocusTo('email');
                });
            }
        };


        account.email = account.email.trim();
        account.password = account.password.trim();
        confirmPassword = confirmPassword.trim();

        if (account.password != confirmPassword) {
            Alert.warning("Επαλήθευση κωδικού", "Η επαλήθευση του κωδικού σας δεν ταιριάζει με τον κωδικό που δηλώσατε!", () => {
                setFocusTo('confirm');
            });
            return;
        }

        let data = {
            action: 'verify-account',
            account,
        }

        R.handle(R.action.request, data, onSuccess, onFailure, LOADER.POPUP);
    }

    // Debug
    // account.password = '123456';
    // confirmPassword = '123456';

    if (!account.email) {
        setFocusTo('email');
    } else {
        setFocusTo('password');
    }
</script>

{#if !completed}
    <p>Ορίστε το email και τον κωδικό για την πρόσβαση στον λογαριασμό σας.</p>
    <div class="row">
        <div class="col-xl-4">
            <form on:submit|preventDefault|stopPropagation="{ submit }">
                <div class="form-group">
                    <label>Email λογαριασμού</label>
                    {#if inputEmail}
                        <input type="email" class="form-control" id="email" bind:value="{account.email}" required>
                    {:else}
                        <div class="form-control-data">{ account.email }</div>
                    {/if}
                </div>
                <div class="form-group">
                    <label>Κωδικός πρόσβασης</label>
                    <PasswordControl id="password" bind:value="{ account.password }"/>
                    <p class="smaller mt-1">{ PASSWORD_TIP }</p>
                </div>
                <div class="form-group">
                    <label>Επαλήθευση κωδικού πρόσβασης</label>
                    <PasswordControl id="confirm" bind:value="{ confirmPassword }"/>
                </div>
                <button class="btn btn-primary btn-block">Επόμενο</button>
            </form>
        </div>
    </div>
{:else}
    <Prompt message="{prompt}"/>
{/if}